// src/app/not-found.tsx

"use client";

import Image from "next/image";
import Link from "next/link";
import React from "react";

import { useTranslations } from "@/context/TranslationsContext";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex justify-center items-center min-h-[80vh] p-8 bg-background">
      <div className="text-center max-w-[600px]">
        <Image
          src="/images/404-illustration.svg"
          alt={t("notFound.imageAlt") || "Page Not Found Illustration"}
          width={400}
          height={300}
          className="mb-8 animate-float mx-auto"
        />
        <h1 className="text-4xl font-bold text-primary mb-4">
          {t("notFound.title") || "Page Not Found"}
        </h1>
        <p className="text-lg text-foreground mb-8">
          {t("notFound.description") ||
            "Oops! The page you're looking for doesn't exist or has been moved."}
        </p>
        <Link
          href="/"
          className="inline-block px-6 py-3 bg-highlight text-white rounded-lg font-semibold transition-colors hover:bg-highlight/80"
        >
          {t("notFound.homeButton") || "Go to Home"}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
